/** Agents screen (tenant/agents.html, P6 group `build`). */
export const agents = {
  title: "Agents",
  subtitle: "Each agent has its own knowledge, audience and channels. People only see the agents they are allowed to use.",
  search: "Search agents…",
  searchLabel: "Search agents",
  create: "Create agent",
  notDeployed: "Not deployed yet",
  plan: {
    used: "{{used}} of {{limit}} agents used on {{plan}}",
    usedUnlimited: "{{used}} agents on {{plan}}",
    remaining_one: "{{count}} remaining",
    remaining_other: "{{count}} remaining",
    full: "Limit reached",
    body: "Agents share the workspace's monthly message allowance. Higher plans include more agents and per-agent message caps.",
    compare: "Compare plans",
    meterLabel: "Agents used",
  },
  card: {
    moreActions: "More actions for {{name}}",
    duplicate: "Duplicate",
    pause: "Pause",
    resume: "Resume",
    publish: "Publish",
    settings: "Settings",
    delete: "Delete",
    audienceOnly: "{{label}} only",
    audiencePublic: "anyone, no sign-in",
    convos: "Convos · 7d",
    resolved: "Resolved",
    sources: "Sources",
    model: "Model",
    modelDefault: "Workspace default",
    lastTrained: "Last trained",
    neverTrained: "Not trained yet",
    processing_one: "{{count}} source still processing",
    processing_other: "{{count}} sources still processing",
    open: "Open",
    playground: "Playground",
  },
  tile: {
    title: "Create agent",
    body: "Start from an industry template or a blank agent.",
    slots_one: "{{count}} slot left on {{plan}}",
    slots_other: "{{count}} slots left on {{plan}}",
    full: "Upgrade to add more agents",
  },
  info: {
    title: "How agents and access work together",
    link: "Audiences & Access",
    kbTitle: "One knowledge base, many agents.",
    kbBody: "Upload a document once and link it to any agent — no duplicate files.",
    accessTitle: "Access is checked on every search.",
    accessBody: "A public visitor can never retrieve a chunk meant for a signed-in audience, even if they ask for it.",
    channelsTitle: "Channels per agent.",
    channelsBody: "Put one agent on your website and Messenger, keep another inside your portal.",
  },
  empty: {
    title: "No agents yet",
    body: "Create your first agent from a template. It starts as a draft you can test in the Playground.",
    noMatch: "No agents match “{{query}}”",
    noMatchBody: "Try another name or clear the search.",
    clear: "Clear search",
  },
  createDialog: {
    title: "Create agent",
    subtitle: "You can change everything later in Agent Settings.",
    name: "Agent name",
    namePlaceholder: "e.g. Clinic Front Desk",
    nameRequired: "Enter a name for the agent.",
    template: "Start from a template",
    recommended: "Recommended",
    showAll: "Show all templates",
    showFewer: "Show fewer templates",
    templatesError: "Templates couldn't load. Try again.",
    audience: "Who can use it",
    audienceHint: "Controls who can chat and which sources it may search.",
    audiencePublic: "{{label}} — anyone",
    audienceOnly: "{{label}} only",
    copy: "Copy knowledge from",
    copyNone: "Don't copy — start empty",
    copyOption: "{{name}} ({{count}} sources)",
    copyHint: "Links existing sources; nothing is re-uploaded.",
    planNote: "This will use {{next}} of {{limit}} agents on your {{plan}} plan. New agents start as Draft and are not visible until you publish them.",
    planNoteUnlimited: "New agents start as Draft and are not visible until you publish them.",
    submit: "Create agent",
    created: "Agent created — add knowledge to train it",
  },
  deleteDialog: {
    title: "Delete {{name}}?",
    body: "The widget, Messenger page and chat link for this agent stop working immediately. Conversation history is kept per your retention policy, then permanently deleted.",
    confirmLabel: "Type DELETE to confirm",
    confirmWord: "DELETE",
    submit: "Delete agent",
    deleted: "Agent deleted. Its knowledge sources were kept.",
  },
  toasts: {
    duplicated: "Duplicated as “{{name}}” — knowledge links kept",
    paused: "{{name}} paused — channels now show your offline message",
    resumed: "{{name}} is live again",
    published: "{{name}} published",
    failed: "That didn't work. Try again.",
  },
} as const;
